import React, { useState, useEffect, useCallback } from 'react';
import Card from '@mui/material/Card';
import MDBox from 'components/MDBox';
import { format } from 'date-fns';
import { intialPageSize, dateFnsFormat } from 'constants';
import { useSelector } from 'react-redux';
import NotesList from './notes/NotesList';
import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';
import { pageSizeChangeHandler } from 'utils/commonUtils';

const AttendanceDataList = () => {
  const [attendanceDataList, setAttendanceDataList] = useState({
    isLoading: false,
    rows: [],
    pageSize: intialPageSize,
    page: 1,
  });

  const { pageSize, page } = attendanceDataList;

  const attendanceInformation = useSelector(
    (state) => state.studentDetails?.item
  );

  useEffect(() => {
    if (attendanceInformation) {
      fetchAttendanceInformation();
    }
  }, [pageSize, page, attendanceInformation]);

  const fetchAttendanceInformation = () => {
    setAttendanceDataList((previous) => ({
      ...previous,
      rows: attendanceInformation?.attendanceData?.notes?.map(
        (item, index) => ({
          id: index,
          week: item.week,
          label: item.label,
          inCompliance: item.inCompliance,
          note: item.note,
          addedAt: format(new Date(item.addedAt), dateFnsFormat),
          addedBy: item.addedBy,
          noteHistory: item.noteHistory?.map((item2, index2) => ({
            id: index2,
            label: item2.label,
            inCompliance: item2.inCompliance,
            note: item2.note,
            addedAt: format(new Date(item2.addedAt), dateFnsFormat),
            addedBy: item2.addedBy,
          })),
        })
      ),
    }));
  };

  const columns = [
    {
      headerName: 'Week',
      field: 'week',
      flex: 1,
    },
    {
      headerName: 'Note',
      field: 'note',
      renderCell: renderCellExpand,
      width: 400,
    },
    {
      headerName: 'Label',
      field: 'label',
      flex: 1,
    },
    {
      headerName: 'In Compliance',
      field: 'inCompliance',
      type: 'boolean',
      flex: 1,
    },
    {
      headerName: 'Added At',
      field: 'addedAt',
      flex: 1,
    },
    {
      headerName: 'Added By',
      field: 'addedBy',
      renderCell: renderCellExpand,
      width: 200,
    },
  ];

  const getDetailPanelContent = useCallback(
    ({ row }) => <NotesList row={row} />,
    []
  );

  const getDetailPanelHeight = useCallback(() => 'auto', []);

  const pageSizeChange = pageSizeChangeHandler(setAttendanceDataList);

  return (
    <>
      <MDBox>
        <Card>
          <DeltaDataGrid
            listData={attendanceDataList}
            columns={columns}
            getDetailPanelContent={getDetailPanelContent}
            getDetailPanelHeight={getDetailPanelHeight}
            setListData={pageSizeChange}
          />
        </Card>
      </MDBox>
    </>
  );
};

export default AttendanceDataList;
